// Word Games progress, remembered per child (player id or guest) and per mode on this device.
// A set = every approved activity of a mode, in a fresh shuffled order; finished activities don't come back
// until the whole set is done, and an unfinished set resumes exactly where the child left off.
const KEY = (playerId, mode) => `kids_wg_progress:${playerId || "guest"}:${mode}`;

export const loadProgress = (playerId, mode) => {
  try {
    const raw = localStorage.getItem(KEY(playerId, mode));
    const p = raw ? JSON.parse(raw) : null;
    return p && Array.isArray(p.order) && p.index < p.order.length ? p : null;
  } catch {
    return null;
  }
};

export const saveProgress = (playerId, mode, progress) => {
  try { localStorage.setItem(KEY(playerId, mode), JSON.stringify(progress)); } catch { /* storage optional */ }
};

export const clearProgress = (playerId, mode) => {
  try { localStorage.removeItem(KEY(playerId, mode)); } catch { /* storage optional */ }
};

export const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

export const newProgress = (ids) => ({ order: shuffle(ids), index: 0, score: 0, streak: 0, bestStreak: 0 });
